export default {
  api_base_url:
    process.env.GATSBY_API_BASE_URL ||
    "https://postal-dev-dot-tough-zoo-144917.uc.r.appspot.com",
  storage_url: "https://storage.googleapis.com",
  bucket: process.env.GATSBY_BUCKET || "postal-staging",
}
